/* tslint:disable */
/* eslint-disable */
/**
 * Watermap Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: srohr-luther@brita.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IngressResponse,
    IngressResponseFromJSON,
    IngressResponseToJSON,
    StringIngressRequest,
    StringIngressRequestFromJSON,
    StringIngressRequestToJSON,
    StringObjectIDictionaryIngressRequest,
    StringObjectIDictionaryIngressRequestFromJSON,
    StringObjectIDictionaryIngressRequestToJSON,
} from '../models';

export interface IngressCsvPostRequest {
    dryRun?: boolean;
    stringIngressRequest?: StringIngressRequest;
}

export interface IngressJsonPostRequest {
    dryRun?: boolean;
    stringObjectIDictionaryIngressRequest?: StringObjectIDictionaryIngressRequest;
}

/**
 * 
 */
export class IngressApi extends runtime.BaseAPI {

    /**
     */
    async ingressCsvPostRaw(requestParameters: IngressCsvPostRequest): Promise<runtime.ApiResponse<IngressResponse>> {
        const queryParameters: any = {};

        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json; charset=utf-8';

        const response = await this.request({
            path: `/ingress/csv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StringIngressRequestToJSON(requestParameters.stringIngressRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IngressResponseFromJSON(jsonValue));
    }

    /**
     */
    async ingressCsvPost(requestParameters: IngressCsvPostRequest): Promise<IngressResponse> {
        const response = await this.ingressCsvPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async ingressJsonPostRaw(requestParameters: IngressJsonPostRequest): Promise<runtime.ApiResponse<IngressResponse>> {
        const queryParameters: any = {};

        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json; charset=utf-8';

        const response = await this.request({
            path: `/ingress/json`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StringObjectIDictionaryIngressRequestToJSON(requestParameters.stringObjectIDictionaryIngressRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IngressResponseFromJSON(jsonValue));
    }

    /**
     */
    async ingressJsonPost(requestParameters: IngressJsonPostRequest): Promise<IngressResponse> {
        const response = await this.ingressJsonPostRaw(requestParameters);
        return await response.value();
    }

}
